<template>
  <div class="comment-list">
    <comment v-for="(comment,index) in comments" v-bind:key="comment.id" :index="index"  :comment="comment" :contentId="contentId"></comment>
  </div>
</template>
<script>
  import Comment from './Comment.vue';
  export default {
    name: 'CommentsList',
    props: ['comments', 'contentId'],
    components:{
      Comment
    }
  }
</script>